export default __webpack_public_path__ + "static/indoor21-42dce1077989a89eb1c7a06d70cb9336.webp";